<template>
  <div class="address-content">
    <p class="transport-company" v-if="['中国大陆(CN)'].indexOf(address.country)==-1">
      {{address.first_name}} {{address.last_name}}
      <span v-if="order">
        <span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}
        </span>
      </span>
    </p>
    <p class="transport-company" v-else>
      <template v-if="!noneedName">
        <label v-if="order && order.id_card_info && order.id_card_info.name">{{ order.id_card_info.name }}</label>
        <template v-else>
          <label style="font-weight:bold;">{{address.last_name}}</label><label>{{address.first_name}}</label>
        </template>
      </template>
      <span v-if="order">
        <span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}
        </span>
      </span>
      <span v-if="showAddButton && order.service_type==2 && isSingle" class="add-address-transport" @click="saveAddrToStore">添加地址</span>
    </p>
    <p class="blod" v-if="address.business_or_private!=2 && address.transport_company"><i class="icon-refresh"></i>{{address.transport_company}} {{address.store_number}}</p>
    <div v-if="showAddButton && isSingle">
      <div v-for="item in totalAccountList">
        <div class="match_div" :class="{'not_match':(+item.match_index)<4}">
          <label class="match_label" :class="{'success':item.status==1,'progress':item.status==2,'danger':item.status==3}">{{item.express_company_name}} {{item.account_name}}
            <el-button :class="{'rotate':loading}" v-if="item.express_company_id=='901'" type="text" style="padding:0 5px;" @click="refreshFanqie">
              <i class="el-icon-refresh"></i>
            </el-button>
          </label>
          <span class="match_text">匹配度：<span>{{item.match_index}}</span></span>
        </div>
        <div v-if="(+item.match_index)<4" class="not_match">
          <label v-if="(+item.match_index)<2">{{item.mobile}}</label>
          <label>{{item.region_city_district+item.address}}</label>
        </div>
        <div v-if="item.express_company_id=='901' && item.info">
          <span>{{item.info}}</span>     
        </div>
      </div>
    </div>
    <p class="blod" v-if="address.business_or_private == 2"><i class="icon-home"></i>私人地址</p>
    <p v-if="singleType && order && order.id_card_info && order.id_card_info.name && order.id_card_info.name.trim()!=address.last_name.trim()+address.first_name.trim()">
      <del>{{address.last_name+address.first_name}}</del>
    </p>
    <p>{{address.address1}}</p>
    <p>{{address.address2}}</p>
    <p>{{address.county?address.county+', ':''}}{{address.city}}, {{address.province}} {{address.zip_code}}</p>
    <p>{{address.country}}</p>
    <p>电话：{{address.mobile}}</p>
  </div>
</template>

<script>
import api from '../../../services/api.js'

export default {
  name: 'AddressList',
  props: ['noneedName','address','support_transport_service','order','isSingle','transportList','totalAccountList','showAddButton','singleType'],
  components: {
  },
  computed: {
  },
  created () {
    this.address = this.address || {}
  },
  data () {
    return {
      loading:false
    }
  },
  methods: {
    async refreshFanqie(){
      let res = await api.post(this, {
            path: 'order.php',
            api: 'add_zhuanyun_address_crawler_process',
            data: {account_id:item.account_id},
            loading:'loading'
          })
          res = res.body         
          if (res.status == 'ok') {
            
          }
    },
    saveAddrToStore(){
      let productCancelDialog = document.getElementById('addAddressToTransport' + this.order.id)
      productCancelDialog.click()
    }
    /*async saveAddrToStore(item){
      item.isbinding=true;
      //this.$emit('saveAddrToStore',item)
      this.$forceUpdate()
      let res = await api.post(this, {
        path: 'order.php',
        api: 'add_address_to_transport_company',
        data: {
          order_id: this.order.id,
          transport_company_id:this.order.shipping_info[0].transport_express_id,
          zhuanyun_account_name:item.zhuanyun_account_name
        },
        loading: 'loading'
      })
      res = res.body
      item.isbinding=false;
      if (res.status == 'ok') {
        item.binded=true;
      }
      this.$forceUpdate()
    }*/
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.transport-company {
  font-size:16px;
  color: #333333;
  line-height:22px;
  margin-bottom: 5px;
}
p {
  color: #666666;
  line-height: 22px;
  white-space: normal;
}
.blod {
  color: #333;
  font-size:16px;
  margin-bottom: 3px;
}

.icon-refresh {
  position: relative;
  margin: 0 5px 0 2px;
  font-size: 12px;
  display: inline-block;
  width: 18px;
  text-align: center;
  color: #fff;
  background-color: #333;
  line-height:18px;
}

.icon-home {
  font-size: 22px;
  line-height:26px;
  position: relative;
  top: 3px;
  margin-right: 3px;
}
.match_text{
  float: right;
  padding-right: 10px;
}
.add-address-transport{
  text-decoration: underline;
  cursor: pointer;
  color:#409eff;
  margin-left:10px;
}
.rotate{
  animation:spin 5s linear infinite
}
.not_match{
  color:#ff4650;
}
.match_label.success{
  border-left:3px solid #1aad19;
  padding-left:2px;
}
.match_label.danger{
  border-left:3px solid #ff4650;
  padding-left:2px;
}
.match_label.progress{
  border-left:3px solid #0f66cf;
  padding-left:2px;
}
@keyframes spin{
  from{
    transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/address/SingleAddress.vue